import { render, staticRenderFns } from "./Croisements.vue?vue&type=template&id=2fb1b9f6&"
import script from "./Croisements.vue?vue&type=script&lang=js&"
export * from "./Croisements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports